module.exports = __webpack_public_path__ + "static/img/icon3.db55ecf1.svg";